export default __webpack_public_path__ + "static/28-flash-drive-053f12825d6ae4c80d8b463e5d70efc5.png";